/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;width:100%}.toolbar-container[_ngcontent-%COMP%]{background:#dedede;height:33px;display:flex;align-items:center}"];
export { styles as styles };
